export default {
  ["Дата начала продаж {date}"]: (date?: string) =>
    `Sotuv boshlanish sanasi ${date}`,
  ["Закрыть"]: "Yopish",
  ["Рекламный слайдер"]: "Reklama slayderi",
  ["Используйте клавиши стрелок для переключения слайдов."]:
    "Slaydlarni oʻzgartirish uchun oʻq tugmalaridan foydalaning.",
  ["Ещё"]: "Ko'proq",
  ["Ещё {number}"]: (number?: number) => `${number} ta ko'proq`,
  ["Убрать"]: "Olib tashlash",
  ["Меню"]: "Menyu",
  ["От {min} до {max} символов"]: (data?: { min: number; max: number }) =>
    `${data?.min} dan ${data?.max} gacha belgi`,
  ["Минимум {count} символ"]: (count?: number) => `Kamida ${count} belgi`,
  ["Выбрать из списка"]: "Roʻyxatdan tanlash",
  ["развернуто"]: "Kengaytirilgan",
  ["свернуто"]: "Yig'ilgan",
  ["Модальное окно"]: "Modal oynasi",
  ["Выбран"]: "Tanlangan",
  ["Не выбран"]: "Tanlanmagan",
  ["Свернуть"]: "Yig‘ish",
  ["Эксклюзив"]: "Eksklyuziv",
  ["Хит продаж"]: "Ko‘p sotilgan",
  ["Новинка"]: "Yangi",
  ["Все книги, получившие эту награду"]:
    "Ushbu mukofotni olgan barcha kitoblar",
  ["Предыдущий слайд"]: "Oldingi slayd",
  ["Следующий слайд"]: "Keyingi slayd",
  ["Оценить книгу на {count} балл из 5"]: (count?: number) =>
    `Kitobni 5 dan ${count} ball bilan baholang`,
  ["Снять оценку"]: "Bahoni olib tashlash",
  ["{star} звезда из 5"]: (star?: number) => `5 dan ${star} yulduz`,
  ["предыдущий таб"]: "Oldingi varaq",
  ["следующий таб"]: "Keyingi varaq",
};
